import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import createRavenMiddleware from 'raven-for-redux';
import reducers from './reducers';
// import saga from './saga';

const sagaMiddleware = createSagaMiddleware({
  onError(error) {
    setImmediate(() => {
      throw error;
    });
  }
});

const middleware = [sagaMiddleware];

if (process.env.REACT_APP_ENV === 'production') {
  window.Raven.config('https://ba662a2b463146368ecd0a59598de5d0@sentry.io/1265129').install();
  middleware.push(createRavenMiddleware(window.Raven));
} else {
  middleware.push(logger);
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const reduxStore = createStore(reducers, composeEnhancers(applyMiddleware(...middleware)));

// sagaMiddleware.run(saga);

export default reduxStore;
